/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InternalApiRisk } from './InternalApiRisk';
import {
    InternalApiRiskFromJSON,
    InternalApiRiskFromJSONTyped,
    InternalApiRiskToJSON,
    InternalApiRiskToJSONTyped,
} from './InternalApiRisk';
import type { InternalApiFinalRisk } from './InternalApiFinalRisk';
import {
    InternalApiFinalRiskFromJSON,
    InternalApiFinalRiskFromJSONTyped,
    InternalApiFinalRiskToJSON,
    InternalApiFinalRiskToJSONTyped,
} from './InternalApiFinalRisk';
import type { InternalApiFinalRiskLevel } from './InternalApiFinalRiskLevel';
import {
    InternalApiFinalRiskLevelFromJSON,
    InternalApiFinalRiskLevelFromJSONTyped,
    InternalApiFinalRiskLevelToJSON,
    InternalApiFinalRiskLevelToJSONTyped,
} from './InternalApiFinalRiskLevel';

/**
 * 
 * @export
 * @interface InternalApiPersonRisks
 */
export interface InternalApiPersonRisks {
    /**
     * 
     * @type {InternalApiFinalRisk}
     * @memberof InternalApiPersonRisks
     */
    lastFinalRisk?: InternalApiFinalRisk;
    /**
     * 
     * @type {Array<InternalApiRisk>}
     * @memberof InternalApiPersonRisks
     */
    risks: Array<InternalApiRisk>;
    /**
     * 
     * @type {InternalApiFinalRiskLevel}
     * @memberof InternalApiPersonRisks
     */
    activeOverrideLevel?: InternalApiFinalRiskLevel;
    /**
     * 
     * @type {string}
     * @memberof InternalApiPersonRisks
     */
    activeOverrideReason?: string;
    /**
     * 
     * @type {Date}
     * @memberof InternalApiPersonRisks
     */
    lastCalculatedTime?: Date;
}



/**
 * Check if a given object implements the InternalApiPersonRisks interface.
 */
export function instanceOfInternalApiPersonRisks(value: object): value is InternalApiPersonRisks {
    if (!('risks' in value) || value['risks'] === undefined) return false;
    return true;
}

export function InternalApiPersonRisksFromJSON(json: any): InternalApiPersonRisks {
    return InternalApiPersonRisksFromJSONTyped(json, false);
}

export function InternalApiPersonRisksFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiPersonRisks {
    if (json == null) {
        return json;
    }
    return {
        
        'lastFinalRisk': json['lastFinalRisk'] == null ? undefined : InternalApiFinalRiskFromJSON(json['lastFinalRisk']),
        'risks': ((json['risks'] as Array<any>).map(InternalApiRiskFromJSON)),
        'activeOverrideLevel': json['activeOverrideLevel'] == null ? undefined : InternalApiFinalRiskLevelFromJSON(json['activeOverrideLevel']),
        'activeOverrideReason': json['activeOverrideReason'] == null ? undefined : json['activeOverrideReason'],
        'lastCalculatedTime': json['lastCalculatedTime'] == null ? undefined : (new Date(json['lastCalculatedTime'])),
    };
}

export function InternalApiPersonRisksToJSON(json: any): InternalApiPersonRisks {
    return InternalApiPersonRisksToJSONTyped(json, false);
}

export function InternalApiPersonRisksToJSONTyped(value?: InternalApiPersonRisks | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'lastFinalRisk': InternalApiFinalRiskToJSON(value['lastFinalRisk']),
        'risks': ((value['risks'] as Array<any>).map(InternalApiRiskToJSON)),
        'activeOverrideLevel': InternalApiFinalRiskLevelToJSON(value['activeOverrideLevel']),
        'activeOverrideReason': value['activeOverrideReason'],
        'lastCalculatedTime': value['lastCalculatedTime'] == null ? value['lastCalculatedTime'] : value['lastCalculatedTime'].toISOString(),
    };
}

